export enum ManualFeedStatusFilter {
  All = 'All',
  Active = 'Active',
  Inactive = 'Inactive',
}
